module.exports = "/fonts/vendor/pe7-icon/dist/Pe-icon-7-stroke.svg?09c6a96523589cb917992cb7b94e2621";